import { converStringToValue, VALUE_TYPES } from "@sdflc/utils";

export const featureValueTypeToIntType = function (
  featureValueType: string
): number {
  switch (featureValueType?.toLowerCase().trim()) {
    default:
    case "string":
    case "text":
      return VALUE_TYPES.STRING;

    case "integer":
      return VALUE_TYPES.INTEGER;

    // ⚠ "number" is the type eventsmagic-api's appFeatures.ts declares for the fee fields
    // (sale_percentage, sale_min_cap, sale_max_cap) and the one provisioning writes to
    // ms_auth. It was missing here, so those three fell through to STRING and every caller
    // that asked for a number got "2.9" — useNumericFeature then read it as 0.
    case "decimal":
    case "number":
      return VALUE_TYPES.DECIMAL;

    case "boolean":
    case "bool":
      return VALUE_TYPES.BOOLEAN;
  }
};

export const getFeatureValue = (
  featureValue: string,
  featueValueType: string,
  defaultValue: undefined | null | string | number | boolean = undefined
): null | string | number | boolean => {
  const value = converStringToValue(
    featureValue,
    featureValueTypeToIntType(featueValueType)
  );

  // ⚠ `== null`, NOT falsy. A plan value of 0 or false is a REAL answer with a declared
  // meaning (sale_max_cap 0 = no cap; guest_list false = headcount only), and a falsy test
  // replaced exactly those with the caller's default — turning "no cap" into whatever the
  // caller guessed.
  if (value == null && defaultValue !== undefined) {
    return defaultValue;
  }

  return value;
};
